/** A4 at 96 CSS px per inch (794 × 1123). Fixed for capture — independent of viewport. */
export const PDF_PAGE_WIDTH_PX = 794;
export const PDF_PAGE_HEIGHT_PX = 1123;

export const PDF_PAGE_PADDING_PX = 32;

export const PDF_EXPORT_ROOT_ID = "pdf-export-root";

/** Usable content height inside page padding (for section packing) */
export const PDF_CONTENT_HEIGHT_PX = PDF_PAGE_HEIGHT_PX - 2 * PDF_PAGE_PADDING_PX;

/** Vertical gap between stacked sections on the same page */
export const PDF_SECTION_GAP_PX = 20;

/** Minimum pages: cover + at least one content page + closing */
export const PDF_MIN_PAGE_COUNT = 3;
